
import * as React from 'react';
import BaseIcon from './BaseIcon';
import BaseIconSvg from './BaseIconSvg'
import { ReactSVG } from 'react-svg';
import { JSX } from 'react';

export interface IBaseTitleIconProps {
  icon?: Promise<any> | JSX.Element;
  src?: string;
  title: string;
  type?: 'h1' | 'h3' | 'h1-yellow';
  className?: string;
  sub?: JSX.Element;
}

export default function BaseTitleIcon(props: IBaseTitleIconProps) {
  const { icon, title, type = 'h3', className = '', sub, src } = props;
  switch (type) {
    case 'h3':
      return (
        <div
          className={'tl-flex tl-mb-4 tl-items-baseline tl-mt-3 ' + className}
        >
          <div className="tl-phr-icon-btn-yellow tl-mr-2">
            {src ? (
              <BaseIconSvg src={src} className="tl-wh-[16px]" />
            ) : icon instanceof Promise ? (
              <BaseIcon icon={icon} className="tl-wh-[16px]" type="solid" />
            ) : (
              icon
            )}
          </div>
          <div>
            <div className="tl-cms-h3 tl-uppercase">{title}</div>
          </div>
        </div>
      );
    // Đang làm dở

    case 'h1':
      return (
        <div className={'tl-flex tl-items-center' + className}>
          <div className="tl-bg-mint-8 tl-rounded-xl tl-wh-[64px] tl-text-white tl-mr-2 tl-flex tl-justify-center tl-items-center tl-flex-none">
            {src ? (
              <BaseIconSvg src={src} className="tl-wh-[32px]" />
            ) : icon instanceof Promise ? (
              <BaseIcon icon={icon} className="tl-wh-[32px]" type="solid" />
            ) : (
              icon
            )}
          </div>
          <div>
            <div className="tl-cms-page-title tl-uppercase tl-font-bold">
              {title}
            </div>
            {sub || ''}
          </div>
        </div>
      );
    case 'h1-yellow':
      return (
        <div className={'tl-flex tl-items-center ' + className}>
          <div className="tl-phr-icon-btn-yellow tl-rounded-xl tl-wh-[64px] tl-text-white tl-mr-2 tl-flex tl-justify-center tl-items-center tl-flex-none">
            {src ? (
              <BaseIconSvg src={src} className="tl-wh-[32px]" />
            ) : icon instanceof Promise ? (
              <BaseIcon icon={icon} className="tl-wh-[32px]" type="solid" />
            ) : (
              icon
            )}
          </div>
          <div className="tl-flex tl-w-full tl-justify-start">
            <div className="tl-cms-page-title tl-uppercase tl-font-bold">
              {title}
            </div>
          </div>
          <div className="tl-flex tl-w-full tl-justify-end">{sub || ''}</div>
        </div>
      );
  }
}

export interface IBaseTitleSVGIconProps {
  icon: string;
  title: string;
  color?:string;
}

export function BaseTitleSVGIcon(props: IBaseTitleSVGIconProps) {
  return (
    <div className="tl-flex tl-mb-4 tl-items-baseline tl-mt-3">
      <div className="tl-phr-icon-btn-yellow tl-mr-2">
        <ReactSVG
          src={props.icon}
          style={{color:props.color}}
          className="tl-wh-[16px]"/>
      </div>
      <div className="tl-cms-h3 tl-uppercase">{props.title}</div>
    </div>
  );
}